import moment, { Moment } from "moment";

import { CROP_TYPE_FCPO, PracticeCrop } from "models";

// This function checks if the year is included in the baseline years or in the years between the baseline and the reporting year
export const getIsBaselineOrHistoricYear = (
  baselineYears: number[] | undefined,
  year: number,
  reportingYear: number | undefined,
  hasSubmittedDataForCurrentYear: boolean
): boolean => {
  if (!reportingYear) return false;
  const targetReportingYear = hasSubmittedDataForCurrentYear ? reportingYear + 1 : reportingYear;
  if (!baselineYears) {
    return year !== targetReportingYear;
  }

  return baselineYears.includes(year) || (year > Math.max(...baselineYears) && year < targetReportingYear);
};

export const getCropRecommendedDates = ({
  crop,
  cropType,
  selectedYear,
}: {
  crop: PracticeCrop;
  cropType: CROP_TYPE_FCPO;
  selectedYear?: number;
}): { recommendedSeedingDate: Moment; recommendedHarvestDate: Moment } | null => {
  if (cropType === CROP_TYPE_FCPO.UNDERSOWING) {
    return null;
  }

  const yearForRecommendation = selectedYear ?? moment().year();
  const recommendedSeedingDayAndMonth = crop.sequestrationValues?.[0]?.seedingStart;
  const recommendedHarvestDayAndMonth = crop.sequestrationValues?.[0]?.harvestStart;

  const seedingStartDate = moment(`${recommendedSeedingDayAndMonth}/${yearForRecommendation}`, "DD/MM/YYYY");
  const harvestEndDate = moment(`${recommendedHarvestDayAndMonth}/${yearForRecommendation}`, "DD/MM/YYYY");

  if (!seedingStartDate.isValid() || !harvestEndDate.isValid()) {
    return null;
  }

  if (harvestEndDate.isBefore(seedingStartDate)) {
    if (cropType === CROP_TYPE_FCPO.MAIN) {
      seedingStartDate.subtract(1, "year");
    }
    if (cropType === CROP_TYPE_FCPO.COVER) {
      harvestEndDate.add(1, "year");
    }
  }
  return { recommendedSeedingDate: seedingStartDate, recommendedHarvestDate: harvestEndDate };
};
